import React, { createContext, useContext } from 'react';

// Create the context
const StepsConfigContext = createContext();

// Provider component
export function StepsConfigProvider({ children, stepsConfig }) {
  return (
    <StepsConfigContext.Provider value={stepsConfig}>
      {children}
    </StepsConfigContext.Provider>
  );
}

// Custom hook to use the context
export function useStepsConfig() {
  const context = useContext(StepsConfigContext);
  if (context === undefined) {
    throw new Error('useStepsConfig must be used within a StepsConfigProvider');
  }
  return context;
}